import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useFullScreen } from "../contexts/FullScreenProvider";

export const CardAgeInfo = ({ ageResult }) => {
  const { isFullScreen } = useFullScreen();
  if (
    !ageResult ||
    (ageResult.age === 0 &&
      ageResult.age_type === null &&
      ageResult.calculated_age === null)
  ) {
    return (
      <div className="info-item d-flex align-items-center mb-2">
        <i className="fas fa-cake-candles mr-2" style={{ fontSize: "12px" }} />
        <span
          className="info-text"
          style={{ fontSize: "0.85rem", color: "#495057" }}
        >
          Age: N/A
        </span>
      </div>
    );
  }

  if (ageResult.age_type === "estimated_dob" && ageResult.calculated_age) {
    return (
      <div>
        <div className="info-item d-flex align-items-center mb-2">
          <i
            className="fas fa-cake-candles mr-2"
            style={{ fontSize: "12px" }}
          />
          <span
            className="info-text"
            style={{ fontSize: "0.85rem", color: "#495057" }}
          >
            Age: {ageResult.calculated_age}
          </span>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip
                id="age-estimated-tooltip"
                className={isFullScreen ? "tooltip-fullscreen" : ""}
              >
                This is an estimated age.
              </Tooltip>
            }
          >
            <i
              className="fa fa-info-circle ml-1 small"
              style={{
                color: "#AF6A3A",
                cursor: "pointer",
                fontSize: "0.9em",
                marginBottom: "2px",
              }}
            />
          </OverlayTrigger>
        </div>
      </div>
    );
  }

  if (ageResult.age_type === "dob" && ageResult.age) {
    return (
      <div>
        <div className="info-item d-flex align-items-center mb-2">
          <i
            className="fas fa-cake-candles mr-2"
            style={{ fontSize: "12px" }}
          />
          <span
            className="info-text"
            style={{ fontSize: "0.85rem", color: "#495057" }}
          >
            Age: {ageResult.age}
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="info-item d-flex align-items-center mb-2">
      <i className="fas fa-cake-candles mr-2" style={{ fontSize: "12px" }} />
      <span
        className="info-text"
        style={{ fontSize: "0.85rem", color: "#495057" }}
      >
        Age: N/A
      </span>
    </div>
  );
};
